import {useEffect} from 'react'
import {shallowEqual, useSelector} from 'react-redux'
import actions from 'redux-auto'
import {useCurrentUserId} from '#hooks/store/useCurrentUserId'

const allAzubisSelector = state => state.azubis.azubisWithPraxisaufgabenModul
const hasAzubisSelector = state => state.authentication.permissions.meineAzubis.hasAzubis
const loadingSelector = state => state.azubis.loading.getAzubisWithPraxisaufgabenModul

export function useAzubisWithPraxisaufgaben({myAufgabenOnly}) {
  const {currentUserId} = useCurrentUserId()
  const hasAzubis = useSelector(hasAzubisSelector)
  const allAzubis = useSelector(allAzubisSelector, shallowEqual) || []

  useEffect(() => {
    if (hasAzubis) {
      actions.azubis.getAzubisWithPraxisaufgabenModul()
    }
  }, [hasAzubis])

  const loading = useSelector(loadingSelector)

  if (myAufgabenOnly) {
    return {
      azubis: [{id: currentUserId}],
    }
  }

  return {
    azubis: allAzubis,
    loading,
  }
}
